import { createContext, FC, ReactNode, useContext } from 'react';
import { Box, styled, SxProps, Theme } from '@mui/material';

import { missingFieldScrollMargin } from '../user-profile.styled-helpers';
import {
  MissingFieldKey,
  missingFieldTargetId,
} from './missing-fields.constants';

const MissingFieldHighlightContext = createContext<string | null>(null);

export const MissingFieldHighlightProvider: FC<{
  highlightedId: string | null;
  children: ReactNode;
}> = ({ highlightedId, children }) => (
  <MissingFieldHighlightContext.Provider value={highlightedId}>
    {children}
  </MissingFieldHighlightContext.Provider>
);

const FieldHighlight = styled(Box, {
  shouldForwardProp: prop => prop !== 'active',
})<{ active?: boolean }>(({ theme, active }) => ({
  ...missingFieldScrollMargin(theme),
  ...(active && {
    '&& .MuiInputBase-root, && .mdxeditor': {
      borderColor: '#CC3300 !important',
      boxShadow: '0 0 0 1px #CC3300',
    },
  }),
}));

interface MissingFieldAnchorProps {
  fieldKey: MissingFieldKey;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export const useHighlightedMissingTarget = (): string | null =>
  useContext(MissingFieldHighlightContext);

export const MissingFieldAnchor: FC<MissingFieldAnchorProps> = ({
  fieldKey,
  children,
  sx,
}) => {
  const highlightedId = useContext(MissingFieldHighlightContext);
  const id = missingFieldTargetId(fieldKey);

  return (
    <FieldHighlight id={id} active={highlightedId === id} sx={sx}>
      {children}
    </FieldHighlight>
  );
};
